const Url = {
  // baseUrl : "https://api.saawariyabook.com/api"
  // baseUrl : "https://api.saawariyabook.com/api"
  baseUrl: "https://api.bp-exch.com/api",
};
export default Url;



// WEBPACK FOOTER //
// ./src/components/configure/configure.js